function ictstores(){
    var stores = [];
    var results = [];
    var params = {
        country: null,
        search: null,
        tags: []
    }
    
    $('[data-ictstore]').each(function(){
        var store = JSON.parse($(this).find('[data-ictstore-data]').val().replaceAll('=>', ':'));
        var clone = $(this).clone();
        var link = $(this).attr('data-ictstore-link') != undefined ? this : $(this).find('[data-ictstore-link]');
        store.country = $(this).find('[data-ictstore-country]').val();
        store.element = clone;
        store.link = $(clone).attr('data-ictstore-link') != undefined ? clone : $(clone).find('[data-ictstore-link]');
        $(link).on('click', function(){
            showStore(store);
        });
        stores[stores.length] = store;
    });

    $('[data-ictstores-search-country]').on('change', function(){
        if($(this).val().length <= 0){
            params.country = null;
        }
        else{
            params.country = $(this).val();
        }
        search();
    });

    $('[data-ictstores-search]').on('input', function(){
        var val = $(this).val().toLowerCase().trim();
        if(val.length <= 0){
            params.search = null;
        }
        else{
            params.search = val;
        }
        search();
    });

    $('[data-ictstores-search-tag]').on('change', function(){
        var tags = [];
        $('[data-ictstores-search-tag]').each(function(){
            if($(this).is(':checked') || $(this).is(':selected')){
                tags[tags.length] = $(this).val();
            }
        });
        params.tags = tags;
        search();
    });

    function search(){
        results = [];
        $(stores).each(function(){
            countryShow = (params.country != null && this.country.toLowerCase().localeCompare(params.country.toLowerCase()) === 0) || params.country == null;
            searchShow = (params.search != null && (this.name.toLowerCase().indexOf(params.search) >= 0 || this.city.toLowerCase().indexOf(params.search) >= 0 || this.address.toLowerCase().indexOf(params.search) >= 0)) || params.search == null;
            tagsShow = params.tags.length <= 0;
            var store = this;
            $(params.tags).each(function(){
                var pt = this;
                $(store.tags).each(function(){
                    if(this.localeCompare(pt) === 0){
                        tagsShow = true;
                    }
                });
            });
            if(countryShow && searchShow && tagsShow){
                results[results.length] = this;
            }
        });
        showResults();
    }

    function showResults(){
        $('[data-ictstores-results]').html('');
        console.log(params);
        if(params.country == null && params.search == null && params.tags.length == 0){
            $('[data-ictstores]').css('display', 'block');
        }
        else{
            $('[data-ictstores]').css('display', 'none');
            if(results.length > 0){
                $(results).each(function(){
                    var store = this;
                    $(store.link).on('click', function(){
                        showStore(store);
                    });
                    $('[data-ictstores-results]').append($(store.element));
                });
            }
        }
    }

    function showStore(store){
        $('[data-ictstores-map]').attr('src', store.map);
        $('[data-ictstores-name]').text(store.name);
        $('[data-ictstores-address]').text(store.address);
        $('[data-ictstores-cap]').text(store.cap);
        $('[data-ictstores-city]').text(store.city);
        $('[data-ictstores-description]').html(store.description);
        $(store.element).addClass('active');
    }

}

